import { FilterTitle } from './FilterTitle';
import { FilterGroup } from './FilterGroup';
import { useFilter } from './hooks';
import { When } from 'react-if';

type FilterProps = {
    showHeader?: boolean;
    title?: string;
    style?: React.CSSProperties;
};

export const Filter = ({
    showHeader = true,
    title,
    style,
}: FilterProps): JSX.Element => {
    const { filterGroups } = useFilter();

    return (
        <div style={style}>
            <When condition={showHeader}>
                <FilterTitle title={title} />
            </When>
            {filterGroups.map((g, idx, all) => (
                <FilterGroup
                    title={g.title}
                    key={g.key}
                    type={g.type}
                    hideDivider={idx === all.length - 1}
                    options={g.options}
                />
            ))}
        </div>
    );
};
